import React, { useMemo } from 'react'
import { Form } from 'react-bootstrap'
import { useStore } from 'react-redux'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectSelectedKeys, setSelectedKeys } from '../../store/meetingSummary/contactUpdate'
import { getAllKeysInData, filterIgnoreFieldsFromKeys } from './utils'
import { RootState } from '../../store/store'

interface ContactSelectionCheckboxProps {
  serviceId: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
  keyParts: string[]
  onKeySelected?: (selectedKey: string, isUnselect: boolean) => void
  className?: string
}

export const ContactSelectionCheckbox: React.FC<ContactSelectionCheckboxProps> = ({ serviceId, data, keyParts, onKeySelected, className }) => {
  const dispatch = useAppDispatch()
  const store = useStore()

  const keys = useMemo(() => getAllKeysInData(data, keyParts.join('.')), [data, keyParts])

  const isSelected = useAppSelector((state) => {
    const selectedKeys = selectSelectedKeys(state)
    if (keys.length === 0) {
      return false
    }
    return keys.every((e) => selectedKeys.includes(e))
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const state = store.getState() as RootState
    const selectedKeys = selectSelectedKeys(state)
    const isChecked = e.target.checked

    if (isChecked) {
      const newKeys = Array.from(new Set([...selectedKeys, ...keys]))
      dispatch(setSelectedKeys(newKeys))
    } else {
      const keysToRemove = filterIgnoreFieldsFromKeys(serviceId, keys)
      const newKeys = selectedKeys.filter((k) => !keysToRemove.includes(k))
      dispatch(setSelectedKeys(newKeys))
    }

    if (onKeySelected) {
      onKeySelected(keyParts[keyParts.length - 1], !isChecked)
    }
  }

  return <Form.Check type='checkbox' checked={isSelected} onChange={handleChange} className={className} />
}
